import React from "react";

import type { ProgressbarProps } from "./progressbar.types";

const Progressbar = ({
  size = "medium",
  progress = 0,
  color,
  width = "100%"
}: ProgressbarProps) => {
  const value = progress * 10;

  return (
    <div
      role="progressbar"
      data-testid="progressbar"
      className={`progressbar ${size}`}
      style={{ width }}
      title={`${value}%`}
    >
      <div
        className="progressbar-bar"
        style={{
          transform: `translateX(${value}%)`,
          backgroundColor: color
        }}
      />
    </div>
  );
};

export default Progressbar;
